import { render, staticRenderFns } from "./ClipWaves.vue?vue&type=template&id=77c21980&"
import script from "./ClipWaves.vue?vue&type=script&lang=js&"
export * from "./ClipWaves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports